module.exports = __webpack_public_path__ + "static/media/mariana.d78ca7de.jpg";